import MApp from "../../modules/MApp";
import MRequest from "../../modules/MRequest";

export default class MDrugs
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-drug-table-container`;

	static addEventListeners()
	{
		document.addEventListener('click', event => {
			const selector = `.profile-drug-entry__delete-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				const buttonEl = event.target.closest(selector);
				const entryEl = buttonEl.closest(`.profile-entry`);
				const url = buttonEl.dataset.url;
				const data = {
					objectId: parseInt(buttonEl.closest('[data-id]').dataset.id),
				};

				entryEl.remove();

				MRequest.post(url, data).then(response => {
					const drugs = new this(document.querySelector(this.selector()));
					drugs.setHtml(response.data.templates.table);
				}).finally(() => {
					MApp.refresh();
				})
			}
		});
	}

	setHtml(html)
	{
		this.el.innerHTML = html;
	}
}
